import NetworkManager from '@services/network-manager';
import { isFirefox } from '@utils/device';

export function isOfflineOnFirefox(): boolean {
  const networkManager = new NetworkManager();
  return isFirefox() && !networkManager.isOnline();
}
